import Breadcrumb from "./Breadcrumb";
import DropdownMenu from "./DropdownMenu";
import PageContent from "./PageContent";
import SearchContent from "./SearchContent";
import SwitchProject from "./SwitchProject";
import Onboarding from "./Onboarding";

const layoutComponents = {
  Breadcrumb,
  DropdownMenu,
  PageContent,
  SwitchProject,
  SearchContent,
  Onboarding
}

export default layoutComponents